import { isRTL } from "@/i18n";
import { useTranslation } from "react-i18next";

export default function PageHeader({ title, highlight, title2, subtitle, children }) {
  const { i18n } = useTranslation();
  const rtl = isRTL(i18n.language);

  return (
    <section className="relative pt-32 pb-16 md:pt-36 md:pb-20 bg-slate-900" dir={rtl ? "rtl" : "ltr"}>
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {children && <div className="mb-6">{children}</div>}
        <h1
          data-testid="page-title"
          className="text-3xl sm:text-4xl lg:text-5xl text-white font-semibold tracking-tight mb-4"
          style={{ fontFamily: "'Outfit', sans-serif" }}
        >
          {title}
          {highlight && <> {highlight}</>}
          {title2 ? ` ${title2}` : ""}
        </h1>
        {subtitle && (
          <p className="text-slate-400 text-base md:text-lg max-w-2xl" style={{ fontFamily: "'Outfit', sans-serif" }}>
            {subtitle}
          </p>
        )}
        <div className="w-12 h-0.5 bg-white/30 mt-8" />
      </div>
    </section>
  );
}
